import React from 'react'
import { Grid, IconButton, Typography } from '@material-ui/core'
import { SelectAllRounded } from '@material-ui/icons'
import { useEmptyStyles } from './empty.styles'

export const EmptyLists = ({ selectedTab }) => {
  const classes = useEmptyStyles()

  const getEmptyText = () => {
    switch (selectedTab) {
      case 0:
        return 'На данный момент у вас нет документов на подписание'
      case 1:
        return 'На данный момент нету подписанных документов'
      case 2:
        return 'На данный момент нету отказанных документов'
      default:
        return 'На данный момент у вас нет документов'
    }
  }

  return (
    <Grid item container>
      <Grid
        item
        container
        xs={12}
        md={12}
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ height: '30vh' }}
      >
        <IconButton size="small" className={classes.icon}>
          <SelectAllRounded />
        </IconButton>
        <Typography className={classes.title}>{getEmptyText()}</Typography>
      </Grid>
    </Grid>
  )
}
